module.exports = __webpack_public_path__ + "img/icon-level-silver.43c1fda7.png";